{
    "coordinates": [
        42.41709979512444,
        -103.75253581723486
    ],
    "tooltip": "Agate",
    "title": "Agate Fossil Beds National Monument",
    "country": "United States",
    "period": "Neogene",
    "alt": "TODO"
}
